<template>
	<li>
		<div :class="attachmentClasses">
			<a :href="file.attachment_permalink || file.download_permalink" :class="previewClasses" target="_blank">
				<img v-if="preview" :src="preview" />
				<template v-else>{{extensionIco}}</template>
			</a>

			<div class="file-meta">
				<strong>{{file.original_name}}</strong>
				{{fileSize}}K

				<template v-if="file.attachment_permalink && canBeViewed">
					| <a :href="file.attachment_permalink" target="_blank">View</a>
				</template>

				<template v-if="previewMain">
					| <a :href="previewMain" :data-lightbox="`file-preview-${file['id']}`" target="_blank">Preview</a>

					<div v-if="previewPages && previewPages.length" class="hidden">
						<a v-for="(page, index) in previewPages" :href="page" :data-lightbox="`file-preview-${file['id']}`" target="_blank">Page {{index + 1}}</a>
					</div>
				</template>

				<template v-if="file.download_permalink">
					| <a :href="file.download_permalink" target="_blank" class="link-download">Download</a>
				</template>

				<template v-if="file.download_cdn_permalink">
					| <a :href="file.download_cdn_permalink" target="_blank">Download from CDN</a>
				</template>
			</div>
		</div>
	</li>
</template>

<script>

export default {
	name: 'comment-file',

	props: {
		file: {
			required: true,
		},
	},

	data () {
		return {};
	},

	computed: {
		attachmentClasses() {
			return [
				'file-attachment',
				{ 'file-attachment-image': this.preview },
			];
		},

		fileSize() {
			return Math.ceil(this.file.size / 1024);
		},

		extension() {
			const { original_name } = this.file;
			const matches = original_name.match(/[^\.]+$/);

			if (!matches) {
				return 'unknown';
			}

			return matches[0].toLowerCase().replace(/[^\w]+/, '');
		},

		extensionIco() {
			return 'ico-' + this.extension;
		},

		previewClasses() {
			if (this.preview) {
				return 'file-preview';
			}

			return ['file-ico', this.extensionIco];
		},

		preview() {
			return this.file.attachment_preview_url || this.previewMain;
		},

		previewMain() {
			if (!this.file.generated_previews || !this.file.generated_previews.length) {
				return null;
			}

			return this.file.generated_previews[0].preview_url;
		},

		previewPages() {
			if (!this.file.generated_previews || !this.file.generated_previews.length) {
				return null;
			}

			return this.file.generated_previews.slice(1).map(preview => preview.preview_url);
		},

		canBeViewed() {
			const supportedFileFormats = [
				'jpg',
				'jpeg',
				'gif',
				'png',
				'pdf',
			];

			return supportedFileFormats.indexOf(this.extension) > -1;
		},

		/*
		attachmentPreview() {
			if (this.file.cdn_thumbnail_name.match(/^thumbs\//)) {
				return `https://${this.file.cdn_bucket}.s3.amazonaws.com/${this.file.cdn_thumbnail_name}`;
			}
			return `/attachment/thumbnail/${this.file.project_token}/${this.file.id}`;
		},
		*/
	},
};
</script>
